export default "__VITE_ASSET__vzgjKca0__"